import { Alert, Stack } from '@mui/material'
import { FC, useEffect } from 'react'
import { useFormContext } from 'react-hook-form'
import { useQuery } from '@tanstack/react-query'
import { useSelector } from 'react-redux'
import { suppliersAPI } from '../../../../api/supplier/suppliersAPI'
import { taxisAPI } from '../../../../api/vehicle/taxisAPI'
import { VehicleFixedRoute } from '../../../../api/vehicle/taxisAPI.types'
import { useSupplierState } from '../../../../Pages/Supplier/SupplierContext'
import ViewFixedRoutePricing from './ViewFixedRoutePricing'

interface ComponentProps {
  taxiId: number | undefined
  isEdit: boolean
}
const ViewFixedRoutePricingComponent: FC<ComponentProps> = (props) => {
  const { chargeExceptions } = useSupplierState()
  const supplierId = useSelector((state: any) => state.suppliers.supplier.id)
  const { taxiId, isEdit } = props
  const formMethods = useFormContext()

  const { data: existingFixedRoutePricingData } = useQuery({
    queryKey: ['getFixedRoutesByTaxiId', taxiId],
    queryFn: async () => taxisAPI.getFixedRoutesByTaxiId(taxiId),
    enabled: !!taxiId,
    refetchOnWindowFocus: false,
  })

  const { data: supplierFixedRoutesData } = useQuery({
    queryKey: ['getSupplierFixedRoutes', taxiId],
    queryFn: async () => suppliersAPI.getSupplierFixedRoutes(supplierId),
    enabled: !!taxiId,
    refetchOnWindowFocus: false,
  })

  const vehicleFixedRoutes: VehicleFixedRoute[] | undefined =
    existingFixedRoutePricingData?.data.value
  const supplierFixedRoutes = supplierFixedRoutesData?.data.value

  useEffect(() => {
    if (vehicleFixedRoutes && formMethods) {
      formMethods.setValue('fixedRoutes', vehicleFixedRoutes, {
        shouldDirty: false,
      })
    }
  }, [vehicleFixedRoutes])

  return (
    <Stack spacing={2}>
      {vehicleFixedRoutes && vehicleFixedRoutes.length === 0 && (
        <Alert severity="info">No fixed routes applied</Alert>
      )}
      {vehicleFixedRoutes &&
        vehicleFixedRoutes.map((vehicleFixedRoute, i) => (
          <ViewFixedRoutePricing
            key={`${i}_${vehicleFixedRoute.fixedRouteId}`}
            index={i}
            isEdit={isEdit}
            chargeExceptions={chargeExceptions}
            fixedRoutes={supplierFixedRoutes || []}
            vehicleFixedRoute={vehicleFixedRoute}
          />
        ))}
    </Stack>
  )
}
export default ViewFixedRoutePricingComponent
